import React from "react";
import styled from "@emotion/styled";
import { theme } from "../../utils/theme";
import Button from "../Button/Button";
import { useNavigate } from "react-router-dom";

const Wrapper = styled.div`
  padding-top: 2rem;
  h2 {
    text-align: center;
  }
`;

const Form = styled.form`
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 60%;
  margin: auto;
  gap: 1rem;

  @media (max-width: 600px) {
    width: 80%;
  }
`;

const Input = styled.input`
  padding: 0.7rem;
  border: 2px solid #808080c9;
`;

const TextArea = styled.textarea`
  padding: 0.7rem;
  border: 2px solid #808080c9;
`;

const SubmitButton = styled.button`
  background-color: ${theme.colors.primary};
  border: none;
  color: white;
  padding: 0.7rem;
  text-decoration: none;
  cursor: pointer;
`;

const SendMail = ({ onSubmit, onChange, subject, email, text }) => {
  const navigate = useNavigate();

  const backHandler = () => {
    navigate(-1);
  };

  return (
    <Wrapper>
      <Button onClickHandle={backHandler} value={"Back"} />
      <Form onSubmit={onSubmit}>
        <h2>Send Mail</h2>
        <Input
          className="form-control"
          name="subject"
          value={subject}
          type="text"
          onChange={onChange}
          placeholder="Input Subject..."
        />
        <Input
          className="form-control"
          name="email"
          value={email}
          type="text"
          onChange={onChange}
          placeholder="Input Email Receiver..."
        />
        <TextArea
          className="form-control"
          name="text"
          value={text}
          type="text"
          onChange={onChange}
          placeholder="Input Message..."
        />
        <SubmitButton type="submit">Send Mail</SubmitButton>
      </Form>
    </Wrapper>
  );
};

export default SendMail;
